<template>
    <div>
        <div class="chart">
            <chartjs-doughnut :labels="labels" :datasets="dataset1" :option="option1" :bind="true"/>
            <div class="percentage-small">
                <strong>{{ results.one.yes }}%</strong> Yes
                <br />
                <strong>{{ results.one.notSure }}%</strong> Not sure
                <br />
                <strong>{{ results.one.no }}%</strong> No
            </div>
            <div class="chart-title" :bind="true">
                {{ questions.one }}
            </div>
        </div>

        <div class="chart">
            <chartjs-bar :labels="labelsBar" :datasets="dataset2" :option="option1" :bind="true"/>
            <div class="chart-title">
                {{ questions.two }}
            </div>
        </div>
        
        <div class="chart">
            <chartjs-doughnut :labels="labels" :datasets="dataset3" :option="option1" :bind="true"/>
            <div class="percentage">
                <strong>{{ results.three.yes }}%</strong>
            </div>
            <div class="chart-title">
                {{ questions.three }} 
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Charts',
    props: ['D1', 'D2', 'D3', 'Q', 'Q2Labels'],
    data() {
        return {
            questions: this.Q,
            labels: ["Yes", "No", "Not sure"],
            labelsBar: ["Bills", "Groceries", "Travel", "Social", "Health"],
            dataset1: this.D1,
            dataset2: this.D2,
            dataset3: this.D3,
            option1: {
                legend: false,
                label: false
            },
            results: {
                one: {
                    yes: null,
                    no: null
                },
                two: {
                    yes: null,
                    no: null,
                    notSure: null
                },
                three: {
                    yes: null,
                    no: null
                }
            }
        }
    },
    methods: {
        convertResults(){
            this.results.one.yes = Math.floor(parseInt(this.D1[0].data[0]) / (parseInt(this.D1[0].data[0]) + parseInt(this.D1[0].data[1]) + parseInt(this.D1[0].data[2])) * 100)
            this.results.one.no = Math.floor(parseInt(this.D1[0].data[1]) / (parseInt(this.D1[0].data[0]) + parseInt(this.D1[0].data[1]) + parseInt(this.D1[0].data[2])) * 100)
            this.results.one.notSure = Math.floor(parseInt(this.D1[0].data[2]) / (parseInt(this.D1[0].data[0]) + parseInt(this.D1[0].data[1]) + parseInt(this.D1[0].data[2])) * 100)



            this.results.two.yes = Math.floor(parseInt(this.D2[0].data[0]) / (parseInt(this.D2[0].data[0]) + parseInt(this.D2[0].data[1])) * 100)
            this.results.three.yes = Math.floor(parseInt(this.D3[0].data[0]) / (parseInt(this.D3[0].data[0]) + parseInt(this.D3[0].data[1])) * 100)
            this.questions = this.Q
            this.labelsBar = [
                this.Q2Labels.param1.label,
                this.Q2Labels.param2.label,
                this.Q2Labels.param3.label,
                this.Q2Labels.param4.label,
                this.Q2Labels.param5.label
            ]
        }
    },
    mounted(){
        let that = this
        setInterval(()=>{
            that.convertResults()
        }, 600)
    }
}
</script>
<style>
.percentage-small{
    position: absolute;
    top: 46px;
    left: 105px;
    font-size: 9px;
    text-align: center;
}
.percentage{
    position: absolute;
    top: 55px;
    left: 119px;
    font-size: 15px;
}
.chart{
    width: 33.333%;
    float: left;
    margin-top: 27px;
    position: relative;
    color: #424242;
}
.chart-title{
    margin: 0px auto 10px auto;
    font-size: 14px;
    padding: 10px;
    color: #424242;
    text-align: center;
}

@media print
{    
.percentage{
    position: absolute;
    top: 55px;
    left: 119px;
    font-size: 15px;
}
.chart{
    width: 33.333%;
    float: left;
    margin-top: 27px;
    position: relative;
    color: #424242;
}
.chart-title{
    margin: 0px auto 10px auto;
    font-size: 14px;
    padding: 10px;
    color: #424242;
    text-align: center;
}
}
</style>